import { createReducer, on } from '@ngrx/store';
import * as CommonActions from './common.actions';
export const commonFeatureKey = 'common';

export interface CommonState {
  userFlag: string;
}

export const CommonInitialState: CommonState = {
  userFlag: 'g'
};

export const commonReducer = createReducer(
  CommonInitialState,
  on(CommonActions.updateUserFlag, (state, { userFlag: flag }) => ({
    ...state,
    userFlag: flag,
  }))
);
